<template>
  <div id="click-box" class="tw-relative tw-w-[421px] tw-px-[12px]">
    <div
      class="tw-text-[#211F58] tw-text-[22px] tw-font-semibold tw-text-center tw-leading-[100%] tw-pb-[20px]"
    >
      {{ getComponentUiText("app-landing-recommendations-page-title-1") }}
    </div>
    <div
      class="tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[150%] tw-text-center"
    >
      {{ getComponentUiText("app-assess-recommendations-no-data-content-1") }}
    </div>
    <div class="tw-text-center">
      <b-button
        variant="primary"
        class="button-verify tw-bg-[#387DFF] tw-mt-[40px] tw-w-fit tw-py-[8px] tw-px-[20px] tw-text-[15px] tw-font-medium tw-rounded-[27px]"
        @click="rejectAssessment"
      >
        {{ getComponentUiText("app-assess-recommendations-no-data-button-1") }}
      </b-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { getComponentUiText } from "@/utils/utilities";
import router from "@/router";

const rejectAssessment = () => {
  router.push({
    path: "/assess/manage",
    query: {
      param: "OpenModalAssessment",
    },
  });
};
</script>
